import {
  SET_PACKAGES_PAGE_DATA,
  SET_PACKAGES_TOTAL_RECORDS,
  SET_PACKAGES_PAGE,
  EDIT_PACKAGES,
  ADD_PACKAGES,
  DELETE_PACKAGES,
  PACKAGES_LOADING,
  PACKAGES_FAILURE,
  GET_PACKAGES,
  SET_PACKAGES_REDIRECT_URL
} from "./packages-constant";

import {
  handleLoading,
  handleFailure,
  handleSetRedirectUrl,
  handleGetData,
  handleSetTotalRecords,
  handleSetPage,
  handleEditItem,
  handleAddItem,
  handleDeleteItems,
} from "../utils/reducerUtils";

// Initial state
const initialState = {
  packagesList: {},
  totalRecords: 0,
  totalPages: 0,
  currentPage: 1,
  loading: false,
  error: null,
  redirectTo: false,
};

export const packagesReducer = (state = initialState, action) => {
  switch (action.type) {
    case PACKAGES_LOADING:
      return handleLoading(state, action);

    case PACKAGES_FAILURE:
      return handleFailure(state, action);

    case SET_PACKAGES_REDIRECT_URL:
      return handleSetRedirectUrl(state, action);

    case GET_PACKAGES:
      return handleGetData(state, action, "packagesList");

    case SET_PACKAGES_TOTAL_RECORDS:
      return handleSetTotalRecords(state, action);

    case SET_PACKAGES_PAGE:
      return handleSetPage(state, action);

    case ADD_PACKAGES:
      return handleAddItem(state, action, "packagesList", "packageId");

    case EDIT_PACKAGES:
      return handleEditItem(state, action, "packagesList", "packageId");

    case DELETE_PACKAGES:
      return handleDeleteItems(state, action, "packagesList", "packageId");

    default:
      return state;
  }
};
